var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconuserverify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62891 14.2001L10.6422 15.2134L12.6689 13.1868",
    stroke: "#12B76A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10575 8.74671C8.03909 8.74004 7.95909 8.74004 7.88575 8.74671C6.29909 8.69337 5.03909 7.39337 5.03909 5.79337C5.03242 4.16004 6.35909 2.83337 7.99242 2.83337C9.62575 2.83337 10.9524 4.16004 10.9524 5.79337C10.9524 7.39337 9.68575 8.69337 8.10575 8.74671Z",
    stroke: "#12B76A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99141 16.0401C6.77807 16.0401 5.57141 15.7334 4.65141 15.1201C3.03807 14.0401 3.03807 12.2801 4.65141 11.2067C6.48474 9.98008 9.49141 9.98008 11.3247 11.2067",
    stroke: "#12B76A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconuserverify);
export default __webpack_public_path__ + "static/media/iconuserverify.a052231c73c2bed9a5591e5ae5677afe.svg";
export { ForwardRef as ReactComponent };